import { useTranslation } from 'lib/i18n'

import Hit from 'components/Filters/types/Hit'
import LocalizedRefinementItem from 'components/Filters/types/LocalizedRefinementItem'

const useLocalisedRefinementItems = (items: LocalizedRefinementItem[]) => {
  const { t } = useTranslation()

  const localise = (label: string) =>
    items.find((item) => item.key === label)?.label(t)

  const toLocalisedLabel = (item: Hit): Hit => ({
    ...item,
    label: localise(item.label),
  })

  return { toLocalisedLabel }
}

export default useLocalisedRefinementItems
